<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">System Configuration</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-settings" />
            System Configuration
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            Approval Berjenjang
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            <template v-if="$route.params.by == 'office-type'">
              Office Type ({{$route.params.code}})
            </template> 
            <template v-else>
              Office ({{$route.params.code}})
            </template>
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            <template v-if="$route.params.by2 == 'apht'">
              APHT
            </template> 
            <template v-else>
              Invoice APHT
            </template>
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow v-if="$helper.isRole($availRoles['HO'])">
      <CCol>
        <CCard class="custom-card">
          <CForm>
            <CCardBody class="p-0">
              <b-table striped hover show-empty
                responsive="xl"
                :items="table.items"
                :fields="table.fields"
                :busy="!table.isLoaded"
                no-local-sorting no-sort-reset
              >
                <template slot="empty">
                  <div v-if="!table.isLoaded" class="text-center">
                    <b-spinner label="Fetching Data..."></b-spinner>
                  </div> 
                  <div v-else class="text-center">
                    Tidak ada data
                  </div> 
                </template>
                <template #cell(approveBy)="row">
                  <b-form-select v-model="row.item.approveBy" :options="table.approveByOptions" @change="onChangeApproveBy(row.index)" style="max-width: 200px;"></b-form-select>
                </template>
                <template #cell(minPokokPembiayaan)="row">
                  <b-form-group
                    class="mb-0"
                    :invalid-feedback="table.validationItems[row.index].minPokokPembiayaan.feedback"
                  >
                    <b-form-input
                      :value="$helper.thousandSeparator(row.item.minPokokPembiayaan)"
                      :state="table.validationItems[row.index].minPokokPembiayaan.isValid"
                      :disabled="row.index == 0"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      @input="row.item.minPokokPembiayaan = $event.toString().replace(/\./g, '')"
                      maxlength="19"
                      type="text"
                      placeholder="Min Pokok Pembiayaan"
                      autocomplete="off"
                      style="max-width: 200px;"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template #cell(values)="row">
                  <b-form-group
                    class="mb-0"
                    v-if="row.item.approveBy == 'jobCode'"
                    :invalid-feedback="table.validationItems[row.index].values.feedback"
                    :state="table.validationItems[row.index].values.isValid"
                  >
                    <multiselect 
                      v-model="row.item.values" 
                      :options="table.jobCodeData.options" 
                      class="mb-0"
                      :class="{custom_multiselect_invalid: table.validationItems[row.index].values.isValid === false}"
                      placeholder="Select an option"
                      :showLabels="false"
                      :loading="!table.jobCodeData.isLoaded"
                      openDirection="bottom"
                      label="text"
                      track-by="value"
                      :internalSearch="false"
                      :multiple="true"
                      :preserveSearch="false"
                      @search-change="populateJobCode"
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                      <template slot="noResult">No elements found.</template>
                      <template slot="afterList" v-if="table.jobCodeData.currentPage < table.jobCodeData.totalPages">
                        <div class="text-center custom-cursor-clickable p-2" @click="appendJobCode" v-if="table.jobCodeData.isLoaded">
                          <span class="text-muted">Load More</span>
                        </div>
                        <div class="text-center" v-else>
                          <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                        </div>
                      </template>
                    </multiselect>
                  </b-form-group>
                  <b-form-group
                    class="mb-0"
                    v-else
                    :invalid-feedback="table.validationItems[row.index].values.feedback"
                    :state="table.validationItems[row.index].values.isValid"
                  >
                    <multiselect 
                      v-model="row.item.values" 
                      :options="table.userData.options" 
                      class="mb-0"
                      :class="{custom_multiselect_invalid: table.validationItems[row.index].values.isValid === false}"
                      placeholder="Select an option"
                      :showLabels="false"
                      :loading="!table.userData.isLoaded"
                      openDirection="bottom"
                      label="text"
                      track-by="value"
                      :internalSearch="false"
                      :multiple="true"
                      :preserveSearch="false"
                      @search-change="populateUser"
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                      <template slot="noResult">No elements found.</template>
                      <template slot="afterList" v-if="table.userData.currentPage < table.userData.totalPages">
                        <div class="text-center custom-cursor-clickable p-2" @click="appendUser" v-if="table.userData.isLoaded">
                          <span class="text-muted">Load More</span>
                        </div>
                        <div class="text-center" v-else>
                          <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                        </div>
                      </template>
                    </multiselect>
                  </b-form-group>
                </template>
                <template #cell(action)="row">
                  <b-button variant="danger" size="sm" title="Remove" @click="removeItem(row.index)" v-if="showRemoveButton">
                    <CIcon name="cil-minus"/>
                  </b-button>
                </template>
                <template #head(action)>
                  <b-button variant="primary" size="sm" title="Add New Row" @click="addItem"><CIcon name="cil-plus"/></b-button>
                </template>
              </b-table>
              <!-- <b-btn @click="testAction">Test</b-btn> -->
              <b-btn variant="primary" class="float-right mr-3 mb-3" type="submit" :disabled="isSubmitting" @click="saveItems">
                <b-spinner small v-if="isSubmitting" />
                {{ isSubmitting ? 'Sedang diproses...' : 'Save' }}
              </b-btn>
            </CCardBody>
          </CForm>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
export default {
  name: 'ConfigApprovalDetail',
  data() {
    return {
      isSubmitting: false,

      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        isLoaded: false,
        fields: [
          {key: "level", label: "Level", sortable: false},
          {key: "approveBy", label: "Approve By", sortable: false},
          {key: "values", label: "Value", sortable: false},
          {key: "minPokokPembiayaan", label: "Min Pokok Pembiayaan", sortable: false},
          {key: "action", label: "", sortable: false}
        ],

        items: [],

        validationItems: [],

        template: {
          approveBy: "jobCode",
          level: 1,
          minPokokPembiayaan: 0,
          values: []
        },

        validationTemplate: {
          minPokokPembiayaan: {
            isValid: null,
            feedback: 'This input is required.',
            isRequired: true,
            payloadKey: "minPokokPembiayaan"
          },
          values: {
            isValid: null,
            feedback: 'This input is required.',
            isRequired: true,
            payloadKey: "values"
          },
        },

        approveByOptions: [
          { value: "jobCode", text: "Job Code" },
          { value: "user", text: "User" },
        ],

        jobCodeData: {
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
        },

        userData: {
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
        },

        currentPage: 1,
      },
    }
  },
  methods: {

    // testAction() {
    //   console.log(this.table)
    // },

    saveItems(event) {
      event.preventDefault()

      let isFormValid = true
      let obj = {}

      // Validation
      let index = 0
      let prevMinPokokPembayaran = 0
      for(const item of this.table.items) {
        if (item.values.length == 0) {
          this.table.validationItems[index].values.isValid = false
          isFormValid = false
        } else{
          this.table.validationItems[index].values.isValid = null
        }

        if (item.minPokokPembiayaan === '') {
          this.table.validationItems[index].minPokokPembiayaan.feedback = "This input is required."
          this.table.validationItems[index].minPokokPembiayaan.isValid = false
          isFormValid = false
        } else if (Number(item.minPokokPembiayaan) < prevMinPokokPembayaran) {
          this.table.validationItems[index].minPokokPembiayaan.feedback = "Amount must be greater than or equals to previous amount."
          this.table.validationItems[index].minPokokPembiayaan.isValid = false
          isFormValid = false
        } else{
          this.table.validationItems[index].minPokokPembiayaan.isValid = null
        }

        prevMinPokokPembayaran = Number(item.minPokokPembiayaan)
        index++
      }

      if (isFormValid) {
        obj.approvers = this.table.items
        let postUrl = ''
        if (this.$route.params.by == 'office-type') {
        // Office Type
        obj.officeType = this.$route.params.code
        if (this.$route.params.by2 == 'apht') {
          // APHT
          postUrl = "/approver/setAPHTByOfficeType"
        } else if (this.$route.params.by2 == 'invoice-apht') {
          // Invoice APHT
          postUrl = "/approver/setInvoiceAPHTByOfficeType"
        }
      } else if (this.$route.params.by == 'office') {
        // Office Code
        obj.officeCode = this.$route.params.code
        if (this.$route.params.by2 == 'apht') {
          // APHT
          postUrl = "/approver/setAPHTByOfficeCode"
        } else if (this.$route.params.by2 == 'invoice-apht') {
          // Invoice APHT
          postUrl = "/approver/setInvoiceAPHTByOfficeCode"
        }
      }
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['HO'])){
          this.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.$store.commit('set', ['toast', true])
              this.$store.commit('set', ['toastMsg', "Set Approval Berjenjang Berhasil! " + (response.data.reason ? response.data.reason : "")])
              this.$router.push({ name: 'Config Approval List', params: { by: this.$route.params.by } });
            }
            else{
              this.$helper.toastError(this, "Set Approval Berjenjang Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Set Approval Berjenjang Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Set Approval Berjenjang Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
        // console.warn(obj)
      }
    },

    removeItem(index) {
      this.table.items.splice(index, 1)
      this.table.validationItems.splice(index, 1)
      this.reorganizeItemLevels()

      if (index == 0) this.table.items[0].minPokokPembiayaan = 0
    },

    reorganizeItemLevels() {
      let index = 1
      this.table.items.forEach(item => {
        item.level = index++
      })
    },

    addItem() {
      let item = this.$lodash.cloneDeep(this.table.template)
      let validationItem = this.$lodash.cloneDeep(this.table.validationTemplate)
      item.level = (this.table.items.length+1)
      this.table.items.push(item)
      this.table.validationItems.push(validationItem)
    },

    addValidationItemOnly() {
      let validationItem = this.$lodash.cloneDeep(this.table.validationTemplate)
      this.table.validationItems.push(validationItem)
    },

    onChangeApproveBy(index) {
      this.table.items[index].values = []
    },

    
    async populateJobCode(query = "") {
      this.table.jobCodeData.isLoaded = false
      this.table.jobCodeData.totalPages = 0
      this.table.jobCodeData.totalRows = 0
      this.table.jobCodeData.currentPage = 1
      this.table.jobCodeData.lastQuery = query
      // URL builder
      let getUrl = "/approver/getJobCodeCabang"
      
      let params = this.$helper.getBasePagedQuery(this.table.jobCodeData.currentPage - 1, this.table.jobCodeData.perPage)
      if(query !== "") {
        params['filterType'] = 'jobName'
        params['filterValue'] = query
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.table.jobCodeData.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.table.jobCodeData.options.push({ value: response.data.data.data[i].jobCode, text: response.data.data.data[i].jobName })
            }
            this.table.jobCodeData.totalRows = response.data.data.totalElements
            this.table.jobCodeData.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.jobCodeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    async populateUser(query = "") {
      this.table.userData.isLoaded = false
      this.table.userData.totalPages = 0
      this.table.userData.totalRows = 0
      this.table.userData.currentPage = 1
      this.table.userData.lastQuery = query
      // URL builder
      let getUrl = "/approver/getUserCabang"
      
      let params = this.$helper.getBasePagedQuery(this.table.userData.currentPage - 1, this.table.userData.perPage)
      if(query !== "") {
        params['filterType'] = 'fullName'
        params['filterValue'] = query
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.table.userData.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.table.userData.options.push({ value: response.data.data.data[i].id, text: response.data.data.data[i].fullName })
            }
            this.table.userData.totalRows = response.data.data.totalElements
            this.table.userData.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.userData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    appendJobCode() {
      this.table.jobCodeData.isLoaded = false
      // URL builder
      let getUrl = "/approver/getJobCodeCabang"
      
      let params = this.$helper.getBasePagedQuery(this.table.jobCodeData.currentPage, this.table.jobCodeData.perPage)
      if(this.table.jobCodeData.lastQuery !== "") {
        params['filterType'] = 'jobName'
        params['filterValue'] = this.table.jobCodeData.lastQuery
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.table.jobCodeData.options.push({ value: response.data.data.data[i].jobCode, text: response.data.data.data[i].jobName })
            }
            this.table.jobCodeData.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.jobCodeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    appendUser() {
      this.table.userData.isLoaded = false
      // URL builder
      let getUrl = "/approver/getUserCabang"
      
      let params = this.$helper.getBasePagedQuery(this.table.userData.currentPage, this.table.userData.perPage)
      if(this.table.userData.lastQuery !== "") {
        params['filterType'] = 'fullName'
        params['filterValue'] = this.table.userData.lastQuery
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.table.userData.options.push({ value: response.data.data.data[i].id, text: response.data.data.data[i].fullName })
            }
            this.table.userData.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.userData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    onLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems()
      }
    },
  
    onPageChange(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems(newPage)
      }
    },

    getTableItems() {
      this.table.isLoaded = false
      this.table.items = []

      // URL builder
      let getUrl = ""
      let params = {}

      if (this.$route.params.by == 'office-type') {
        // Office Type
        if (this.$route.params.by2 == 'apht') {
          // APHT
          getUrl = "/approver/getAPHTByOfficeType"
          params['officeType'] = this.$route.params.code
        } else if (this.$route.params.by2 == 'invoice-apht') {
          // Invoice APHT
          getUrl = "/approver/getInvoiceAPHTByOfficeType"
          params['officeType'] = this.$route.params.code
        }
      } else if (this.$route.params.by == 'office') {
        // Office Code
        if (this.$route.params.by2 == 'apht') {
          // APHT
          getUrl = "/approver/getAPHTByOfficeCode"
          params['officeCode'] = this.$route.params.code
        } else if (this.$route.params.by2 == 'invoice-apht') {
          // Invoice APHT
          getUrl = "/approver/getInvoiceAPHTByOfficeCode"
          params['officeCode'] = this.$route.params.code
        }
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          let resp = response.data.data
          if (response.data.data == null) {
            resp = [this.$lodash.cloneDeep(this.table.template)]
          }
          this.table.items = resp
          for(let i = 0; i < resp.length; i++) {
            this.addValidationItemOnly()
          }
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "List Approval Berjenjang Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "List Approval Berjenjang Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "List Approval Berjenjang Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    },

    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },
  },

  computed:{
    showRemoveButton(){
      if (this.$route.params.by == 'office-type') {
        if (this.table.items.length > 1) {
          return true
        } else{
          return false
        }
      } else{
        return true
      }
    }
  },

  async created(){
    await this.populateJobCode()
    await this.populateUser()

    this.getTableItems()
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>